import { Injectable, signal } from '@angular/core';
import type { CommentIndicatorResponse } from '@libs/core/comment-section/responses/comment.response';

type IndicatorEntry = Omit<CommentIndicatorResponse, 'contextId'>;

@Injectable({ providedIn: 'root' })
export class PlannerLogStateService {
  readonly selectedMaterialId = signal<string | null>(null);
  readonly commentIndicators = signal<Map<string, IndicatorEntry>>(new Map());

  selectMaterial(materialId: string): void {
    this.selectedMaterialId.set(materialId);
  }

  clearSelection(): void {
    this.selectedMaterialId.set(null);
  }

  setIndicators(queriedIds: string[], list: CommentIndicatorResponse[]): void {
    const updated = new Map(this.commentIndicators());
    for (const id of queriedIds) {
      updated.delete(id);
    }
    for (const i of list) {
      updated.set(i.contextId, {
        count: i.count,
        unreadCount: i.unreadCount,
        oldestUnreadId: i.oldestUnreadId,
      });
    }
    this.commentIndicators.set(updated);
  }

  getIndicator(materialId: string): IndicatorEntry | undefined {
    return this.commentIndicators().get(materialId);
  }

  markMaterialRead(materialId: string): void {
    const current = this.commentIndicators();
    const entry = current.get(materialId);
    if (entry && entry.unreadCount > 0) {
      const updated = new Map(current);
      updated.set(materialId, {
        count: entry.count,
        unreadCount: 0,
        oldestUnreadId: null,
      });
      this.commentIndicators.set(updated);
    }
  }

  addFromSseNotification(referenceId: string | null): void {
    if (!referenceId) return;
    const current = this.commentIndicators();
    const updated = new Map(current);
    const entry = current.get(referenceId);
    if (entry) {
      updated.set(referenceId, {
        count: entry.count + 1,
        unreadCount: entry.unreadCount + 1,
        oldestUnreadId: entry.oldestUnreadId,
      });
    } else {
      updated.set(referenceId, {
        count: 1,
        unreadCount: 1,
        oldestUnreadId: null,
      });
    }
    this.commentIndicators.set(updated);
  }
}
